<script setup lang="ts">
const runtimeConfig = useRuntimeConfig();

const isCaptchaLoading = ref(true);
const isCaptchaNotValid = ref(false);
const isCaptchaVisible = ref(false);
const captchaToken = defineModel<string>();
const turnstile = ref();

const resetCaptcha = () => {
  isCaptchaNotValid.value = false;
  isCaptchaLoading.value = true;
  turnstile.value.reset();
};

// TODO: Check this case when the user even on invisible captcha is asked to interact with the turnstile
const handleCaptchaErrors = (error: string) => {
  console.log(isCaptchaVisible, `Captcha error: ${error}`);
  // When captcha needs interaction
  if (error === "300030") {
    isCaptchaVisible.value = true;
  }

  isCaptchaVisible.value = true;
};

const handleInteractiveCallback = () => {
  if (captchaToken.value === null) {
    isCaptchaVisible.value = true;
  }
};

watch(captchaToken, (val) => {
  if (val) {
    isCaptchaLoading.value = false;
  }
});
</script>

<template>
  <div class="flex flex-col items-center mt-2 gap-3" v-if="runtimeConfig.public.CAPTCHA_ENABLED">
    <template v-if="runtimeConfig.public.CAPTCHA_PROVIDER === 'turnstile'">
      <small v-if="!isCaptchaVisible" :class="{
              'bg-darken-warning text-warning border border-warning': isCaptchaNotValid,
              '': !isCaptchaNotValid && !isCaptchaLoading
            }" class="flex gap-1 items-center opacity-70 rounded-full text-[10px] px-2 py-0.5">
              <span @click="resetCaptcha" class="cursor-pointer" v-if="isCaptchaNotValid">Falha na validação. <span
                class="underline">Tentar novamente</span></span>
        <span v-else>{{ isCaptchaLoading ? "Validando formulário" : "Formulário validado" }}</span>
        <Icon v-if="!isCaptchaNotValid" :class="{ 'animate animate-spin': isCaptchaLoading }"
              :name="isCaptchaLoading ? 'fa6-solid:circle-notch' : 'fa6-solid:shield-halved'" />
      </small>
      <NuxtTurnstile :class="isCaptchaVisible ? 'opacity-100' : 'absolute opacity-0 pointer-events-none'"
                     v-model="captchaToken" :options="{
              theme: 'dark',
              'error-callback': (error) => handleCaptchaErrors(error),
              'before-interactive-callback': () => handleInteractiveCallback(),
            }" />
    </template>

  </div>
</template>